import { useCallback, useEffect, useState } from "react";
import { Box, Button, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useLazyGetCuentasByIdQuery } from "@api/account";
import { signOut } from "aws-amplify/auth";
import { RootState, useAppDispatch } from "@store/store";
import { InactivityHandler } from "@components/InactivityHandler";
import CustomRightImage from "@components/CustomRightImagev2";
import IconRejected from "@components/Images/IconRejected";
import { setModalErrorVisible } from "@store/slices/appSlice";
import { ApiError } from "@interfaces/response";

const RechazoManual = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));

  const personalData = useSelector((state: RootState) => state.register.personal_data);

  const [getAccountData] = useLazyGetCuentasByIdQuery();

  const [name, setName] = useState("");

  const handleClick = async () => {
    await signOut();
    navigate("/login");
  };

  const fetchData = useCallback(async () => {
    try {
      const response = await getAccountData({ id: personalData.id }).unwrap();
      const account_data = response.data;
      const fullName = `${account_data.name} ${account_data.last_name} ${account_data.last_name_2}`;
      setName(fullName);
    } catch (error) {
      dispatch(setModalErrorVisible({ open: true, error: error as ApiError }));
    }
  }, [getAccountData, personalData.id, dispatch]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <Grid container height="100%">
      <Grid item xs={12} md={8} mt={5}>
        <InactivityHandler />
        <Box>
          <Typography
            variant={isMobileOrTablet ? "h4" : "h3"}
            color={theme?.palette?.primary?.main}
            fontWeight={500}
            align="center"
          >
            ¡Hola!
          </Typography>

          <Typography
            variant={isMobileOrTablet ? "h4" : "h3"}
            color={theme?.palette?.primary?.main}
            fontWeight={500}
            align="center"
          >
            {name}
          </Typography>

          <Typography
            variant={isMobileOrTablet ? "body2" : "body1"}
            color={theme?.palette?.primary?.dark}
            align="center"
            mt={3}
          >
            Lo sentimos mucho, lamentamos informarte que tu solicitud de crédito ha sido rechazada
          </Typography>

          <Box display="flex" justifyContent="center" mt={4}>
            <IconRejected width={isMobileOrTablet ? "150" : "200"} fill={theme.palette.primary.light} />
          </Box>

          <Typography
            variant={isMobileOrTablet ? "body2" : "body1"}
            color={theme?.palette?.primary?.dark}
            align="center"
            mt={3}
          >
            Para mayor información, contacta a tu asesor
          </Typography>

          <Box display="flex" justifyContent="center" mt={3}>
            <Button variant="default" onClick={handleClick} sx={{ width: "130px" }}>
              Salir
            </Button>
          </Box>
        </Box>
      </Grid>
      {!isMobileOrTablet && (
        <Grid item xs={12} md={4}>
          <CustomRightImage />
        </Grid>
      )}
    </Grid>
  );
};

export default RechazoManual;
